<template>
  <Graphics />
</template>
<script>
import Graphics from '@/components/graphics/Graphics';

export default {
    name: 'ClientGraphics',
    components: {
        Graphics,
    },
};
</script>
